import { useTranslation } from 'react-i18next'

import { ButtonContinue } from 'shared/ui/bottom-continue'

interface Props {
  onClick: () => void
  disabled?: boolean
}

export const ButtonCalendar = ({ disabled, onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <ButtonContinue
      onClick={onClick}
      disabled={disabled}
    >
      <span className="bold-17">{t('select_without_date')}</span>
    </ButtonContinue>
  )
}
